import { render, staticRenderFns } from "./ContractAttachments.vue?vue&type=template&id=5f1a4e3e&"
import script from "./ContractAttachments.vue?vue&type=script&lang=js&"
export * from "./ContractAttachments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports